import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { isScanRunInProgress } from "shared/Scan/access/useCanTriggerScan";
import { getDuration } from "utils/time";

import { ScanRunsListItem } from "../../../types";

const ScanRunsTableDurationCell = ({
  item: run,
  ...cellProps
}: TableSimpleCellProps<ScanRunsListItem>) => {
  const duration = isScanRunInProgress(run.state)
    ? undefined
    : getDuration(run.stateChangedAt - run.createdAt, true);

  return (
    <TableSimpleCell {...cellProps}>
      {duration ? <TableCellText>{duration}</TableCellText> : <TableCellEmpty />}
    </TableSimpleCell>
  );
};

export default ScanRunsTableDurationCell;
